import type { IAnalyticsMessagesParams } from "@frontend-shared/types";
import { useQuery } from "@tanstack/react-query";

import { analyticsApi } from "@/api/services";

interface IUseGetMessagesProps extends IAnalyticsMessagesParams {
  enabled?: boolean;
}

export const MESSAGES_QUERY_KEY = "messages";

export const useGetMessages = ({
  limit = 10,
  offset = 0,
  sortColumn,
  sortOrder,
  enabled = true,
  hasAllMembersAnalyticsReadPermission,
  memberUuids,
  direction,
  source,
  status,
  modelTitle,
  providerName,
  assistantName,
  dateFrom,
  dateTo,
  projectUuid,
  scope,
  deletionStatus,
  search,
}: IUseGetMessagesProps) => {
  return useQuery({
    // NOTE: projectUuid + scope are part of the key so switching the Messages
    // tab's scope dropdown does not show stale rows from the previous scope.
    queryKey: [
      MESSAGES_QUERY_KEY,
      projectUuid,
      scope,
      limit,
      offset,
      sortColumn,
      sortOrder,
      memberUuids,
      direction,
      source,
      status,
      modelTitle,
      providerName,
      assistantName,
      dateFrom,
      dateTo,
      deletionStatus,
      search,
    ],
    queryFn: () =>
      analyticsApi.getMessages({
        hasAllMembersAnalyticsReadPermission,
        limit,
        offset,
        sortColumn,
        sortOrder,
        memberUuids,
        direction,
        source,
        status,
        modelTitle,
        providerName,
        assistantName,
        dateFrom,
        dateTo,
        projectUuid,
        scope,
        deletionStatus,
        search,
      }),
    enabled,
  });
};
